import EventScorekeepingScore from '@/screens/EventScorekeepingScore';

export default function PrivateEventEventIdScorekeepingScoreIndexRoute() {
  return <EventScorekeepingScore />;
}
